export const brandServices = [
    {
        icon: 'iconfont icon-jingli',
        title: '技术经理人',
        subtitle: '纳入省技术产权交易市场管理，以实现科技成果转化和技术转移服务为目的，促成技术持有方与技术需求方达成交易或合作的自然人。',
        url: '/images/manager',
        linkurl: 'https://www.jssic.cn/#/kjzy/kjrc/jsjlrExpert?key=QjhEc0ZMkbnmvt2r50FGSrpc%2FfXswKPepC2r%2FXmmZ3s%3D',
        content: `为促进江苏省技术经理人队伍发展，规范技术经理人从事技术转移、成果转化服务行为，推进科技成果转化和技术转移市场健康有序发展，江苏省技术产权交易市场对技术经理人进行认证备案管理，纳入省技术产权交易市场管理的技术经理人可自愿选择挂靠技术经理人事务所，并在事务所协助下开展技术服务活动，并享有优先使用省技术市场的线下中心、依照相关的法律法规获得佣金和收益、享受江苏省内相关激励政策、技术经理人事务所内资源池流通共享等相关权利。技术经理人利用省技术市场平台资源或需求，通过咨询诊断、分析调研及对接撮合等居间服务方式，促成技术持有方与技术需求方达成交易或合作。 `
    },
    {
        icon: 'iconfont icon-jigou',
        title: '技术经理人事务所',
        subtitle: '在江苏境内注册，具有独立法人资格的高校院所技术转移中心、新型研发机构以及从事技术转移相关工作的机构或社团组织。',
        url: '/images/jsjlr',
        linkurl: 'https://www.jssic.cn/#/jsjlr?id=2',
        content: '省技术产权交易市场为进一步构建更加完善的全省技术转移服务体系，高质量推进科技成果转化和产业化，规范技术经理人从事技术转移服务的行为，促进技术经理人职业健康发展，保障技术经理人合法权益，扶持和培育的一批技术转移专业服务机构。'
    },
    // {
    //     icon: 'iconfont icon-jigou',
    //     title: '技术经理人事务所',
    //     subtitle: '省技术产权交易市场认定的促进技术经理人执业健康发展，保障技术经理人合法权益的机构。',
    //     url: '/images/jsjlr',
    //     linkurl: 'https://www.jssic.cn/#/jsjlr?id=2',
    //     content:
    //         '为规范技术经理人从事技术转移服务相关业务管理，促进技术经理人职业健康发展，保障技术经理人合法权益。江苏省技术产权交易市场设立技术经理人事务所，吸纳及挂靠技术经理人开展业务，并进行管理。省技术产权交易市场认定一批来自科研机构高校院所金融机构企业以及新型研发机构的技术经理人，技术经理人挂靠在省技术市场认定的事务所，并由他们提供物理场所 票据结算等服务。第一批技术经理人事务所包括高校技术转移中心、协会、新型研发机构等。'
    // },
    // {
    //     icon: 'iconfont icon-business',
    //     title: '商服SOHO',
    //     subtitle: '一站式商务服务，创业者的全能管家。',
    //     url: '/images/soho',
    //     content:
    //         '初创企业，由于人员配备不足及资源的缺乏，亟需解决工商、财税、法务、人力、商标、知识产权、媒体推广、品牌塑造等一系列的专业问题。“商服SOHO”，通过严格筛选和过程监督相关领域服务商，为初创企业提供专业化的打包服务，解决初创企业后顾之忧的同时，保持初创企业的灵活性。为初创企业的快速发展保驾护航。'
    // },
    // {
    //     icon: 'iconfont icon-keji',
    //     title: '技术交易融资服务',
    //     subtitle: '联合银行、创投等专业服务机构，基于技术交易分析数据为企业提供专项融资服务，解决企业在研发创新和生产经营活动中产生的资金短缺难题，联合银行为企业量身定制贷款或融资产品，满足不同企业需求。',
    //     url: '/images/jyd',
    //     linkurl: 'https://www.jssic.cn/#/zxzx/tzggDet?id=382',
    //     content:
    //         '一、“交易贷”1.服务对象：参与省“成果（专利）拍卖季”和J-TOP创新挑战季”活动及发生技术交易的科技型企业。2.产品简介：根据近两年企业技术合同成交额 （以江苏省技术合同认定登记系统认定登记的技术合同为准），结合企业生产经营状况、实际资金需求以及偿债能力等综合确定授信额度，授信金额最高3000万元，授信期限最长3年。二、“仪器贷”1.服务对象：为从事国产科学仪器研发的企业，以及使用省科技资源统筹服务云平台科学仪器共享服务的企业。2.产品简介：流动资金或固定资产贷款，贷款额度一般不超过3000万元，对于重点领域、高端装备研发生产企业，贷款额度最高可达5000万元。'
    // }
    {
        icon: 'iconfont icon-keji',
        title: '科技金融服务',
        subtitle: '联合银行、创投等专业服务机构，基于技术交易分析数据为企业提供专项融资服务，解决企业在研发创新和生产经营活动中产生的资金短缺难题，联合银行为企业量身定制贷款或融资产品，满足不同企业需求。',
        url: '/images/jyd',
        linkurl: '/finance',
        content: "一、“交易贷”1.服务对象：参与省“成果（专利）拍卖季”和J-TOP创新挑战季”活动及发生技术交易的科技型企业。2.产品简介：根据近两年企业技术合同成交额 （以江苏省技术合同认定登记系统认定登记的技术合同为准），结合企业生产经营状况、实际资金需求以及偿债能力等综合确定授信额度，授信金额最高3000万元，授信期限最长3年。\n 二、“仪器贷”1.服务对象：为从事国产科学仪器研发的企业，以及使用省科技资源统筹服务云平台科学仪器共享服务的企业。2.产品简介：流动资金或固定资产贷款，贷款额度一般不超过3000万元，对于重点领域、高端装备研发生产企业，贷款额度最高可达5000万元。"
    }
    // {
    //     icon: '',
    //     title: '科技人才',
    //     subtitle: '科技人才是省技术产权交易市场围绕我省产业链集群，重点面向高等学校、科研院所、科技型企业等对象，征集具有技术研发、技术转移、科技成果转化、科技管理等专业知识和实践经验的人才。',
    //     url: '/images/kjrc',
    //     linkurl: 'https://www.jstec.com.cn/talentZone',
    //     content:
    //         '省技术产权交易市场通过“需求张榜、在线揭榜”方式构建完善以需求为导向的技术转移服务体系，聚焦我省重点产业链上下游，集聚一批技术专家、产业专家、运营管理专家、服务机构专家，依托平台资源汇聚优势，发挥人才支撑科技创新的中坚力量，积极推动参与“成果（专利）拍卖季”“J-TOP创新挑战季”技术转移品牌活动，充分释放资源共享服务效能，加快科技成果转化与产业化，促进技术交易。'
    // }
]

export const mobileList = [
    {
        name: '技术市场小程序',
        qrCode: require('@/assets/images/mobile/mall_qrcode.jpg')
    }
    // ,
    // {
    //     name: '执业技术经理人小程序',
    //     qrCode: require('~/assets/images/mobile/manager_qrcode.jpg')
    // },
    // {
    //     name: '创新挑战小程序',
    //     qrCode: require('~/assets/images/mobile/jtop_qrcode.jpg')
    // },
    // {
    //     name: '活动助理小程序',
    //     qrCode: require('~/assets/images/mobile/activity_qrcode.jpg')
    // },
    // {
    //     name: '店铺管家小程序',
    //     qrCode: require('~/assets/images/mobile/shop_qrcode.jpg')
    // },
    // {
    //     name: '智能助手小程序',
    //     qrCode: require('~/assets/images/mobile/ai_qrcode.jpg')
    // }
]

export const navigationList = [
    {
        title: '新手推荐',
        linkArr: [
            {
                name: '用户中心',
                system: 'bcs',
                url: '/person'
            },
            {
                name: '实名认证',
                system: 'bcs',
                url: '/realname'
            },
            {
                name: '身份申请',
                system: 'bcs',
                url: '/identity'
            },
            {
                name: '修改密码',
                system: 'bcs',
                url: '/passwordChange'
            },
            // {
            //     name: '我的积分',
            //     system: 'bcs',
            //     url: '/points'
            // },
            {
                name: '我的收藏',
                system: 'bcs',
                url: '/collection'
            },
            {
                name: '活动大厅',
                system: 'portal',
                url: '/activity'
            },
            // {
            //     name: '我的等级',
            //     system: 'bcs',
            //     url: '/experience'
            // },
            // {
            //     name: '我的信用',
            //     system: 'bcs',
            //     url: '/credit'
            // },
            {
                name: '帮助中心',
                system: 'portal',
                needLogin: false,
                url: '/help'
            },
            {
                name: '积分商城',
                system: 'portal',
                needLogin: false,
                url: '/points'
            },
            {
                name: '在线客服',
                system: 'portal',
                needLogin: false,
                url: '/kefu'
            }
        ]
    },
    {
        title: '买家服务',
        linkArr: [
            {
                name: '发布需求',
                system: 'bcs',
                url: '/demandCrowd?role=buyer'
            },
            {
                name: '订单监控',
                system: 'bcs',
                url: '/purchase?role=buyer'
            },
            {
                name: '创新挑战',
                system: 'bcs',
                url: '/demandCrowd?role=buyer'
            },
            {
                name: '专利商城',
                system: 'portal',
                needLogin: false,
                url: '/search?page=1&rows=10&category=goods&goodsType=01'
            },
            {
                name: '成果商城',
                system: 'portal',
                needLogin: false,
                url: '/search?page=1&rows=10&category=goods&goodsType=02'
            },
            {
                name: '服务商城',
                system: 'portal',
                needLogin: false,
                url: '/search?page=1&rows=10&category=goods&goodsType=03'
            },
            {
                name: '智能匹配',
                system: 'bcs',
                needLogin: true,
                url: '/intelligent/demand'
            },
            {
                name: '店铺大厅',
                system: 'portal',
                needLogin: false,
                url: '/search?page=1&rows=10&category=shop'
            },
            {
                name: '参与竞拍',
                system: 'bid',
                url: ''
            }
            // {
            //     name: '新闻资讯',
            //     system: 'portal',
            //     needLogin: false,
            //     url: '/search?page=1&rows=10&category=information'
            // }
        ]
    },
    {
        title: '卖家服务',
        linkArr: [
            {
                name: '发布商品',
                system: 'bcs',
                url: '/commodity'
            },
            {
                name: '店铺管理',
                system: 'bcs',
                url: '/myshop'
            },
            {
                name: '订单管理',
                system: 'bcs',
                url: '/sale'
            },
            {
                name: '员工管理',
                system: 'bcs',
                url: '/staff'
            },
            // {
            //     name: '代理管理',
            //     system: 'bcs',
            //     url: '/agented'
            // },
            {
                name: '智能匹配',
                system: 'bcs',
                url: '/intelligent/good'
            },
            // {
            //     name: '客服管理',
            //     system: 'bcs',
            //     url: '/communication'
            // },
            {
                name: '解决方案',
                system: 'bcs',
                url: '/dealDemand'
            },
            {
                name: '公示专栏',
                system: 'portal',
                url: '/publicity'
            },
            {
                name: '挂牌专栏',
                system: 'portal',
                url: '/listed'
            },
            {
                name: '合同登记',
                system: 'portal',
                needLogin: false,
                url: '/technicalContractsRegistration/index'
            }
        ]
    }
]

export const systemList = [
    {
        name: '智能匹配',
        describe: '智能分析产品，精确定位客户',
        system: 'bcs',
        url: '/intelligent/good'
    },
    {
        name: '高校OA',
        describe: '高校院所技术交易智能管家',
        system: 'college',
        url: ''
    },
    {
        name: '在线竞拍',
        describe: '在线技术交易新模式',
        system: 'bid',
        url: 'http://bid.jstec.com.cn/'
    },
    {
        name: '创新挑战',
        describe: '为你的研发创新 提供定制化服务',
        system: 'jtop',
        url: '/crowdsourcing'
    },
    {
        name: '大数据系统',
        describe: '把握产业，科技产品关键时刻',
        system: 'analysis',
        url: 'https://analysis.jstec.com.cn/'
    }
]
